export { ViewHomepageResource as default, searchComponentVirtualAgentResource } from './resources';
